import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));

const compactUsd = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    notation: 'compact',
    maximumFractionDigits: 1,
});

const compactNumber = new Intl.NumberFormat('en-US', {
    notation: 'compact',
    maximumFractionDigits: 1,
});

const usd2 = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

const isNum = (v: number | null | undefined): v is number =>
    typeof v === 'number' && Number.isFinite(v);

export const formatCompactUsd = (v: number | null | undefined): string =>
    isNum(v) ? compactUsd.format(v) : '—';

export const formatCompact = (v: number | null | undefined): string =>
    isNum(v) ? compactNumber.format(v) : '—';

export const formatPrice = (v: number | null | undefined): string =>
    isNum(v) ? usd2.format(v) : '—';

export const formatSignedPct = (v: number | null | undefined, digits = 2): string =>
    isNum(v) ? `${v >= 0 ? '+' : ''}${v.toFixed(digits)}%` : '—';

export const formatPct = (v: number | null | undefined, digits = 2): string =>
    isNum(v) ? `${v.toFixed(digits)}%` : '—';

export const formatDate = (iso: string | null | undefined): string => {
    if (!iso) return '—';
    const d = new Date(`${iso.slice(0, 10)}T00:00:00Z`);
    if (Number.isNaN(d.getTime())) return iso;
    return d.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        timeZone: 'UTC',
    });
};

export const stockInfoRoute = (symbol: string): string =>
    `/dashboard/stock-info-page?symbol=${encodeURIComponent(symbol)}`;
